const Token = (($) => {

    const NAME = 'token';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        maxTags: null,  // max # of tags
        url: null,      // url to retrieve data
        wildcard: null, // add wildcard to url
        cache: true,    // prefetch to cache or remote
        object: false,  // data as object or string
        minLength: 1,   // char min length to trigger search
        hint: true,     // show hint
        highlight: true,// show highlight
        limit: 10,      // limit the result
        values: null    // default value
    };
    const Selector = {
        CLASS_NAME: `.js-${NAME}`
    }

    class Token {
        constructor(element, config) {
            this._config = config;
            this._element = element;
            this._$element = $(element);
            const disabled = this._$element.prop('disabled') || this._$element.prop('readonly');
            if (disabled) {
                this._$element.siblings('.bootstrap-tagsinput').addClass('disabled');
            }

            if (config.url) {
                let bloodhound;

                if (config.cache) {
                    bloodhound = new Bloodhound({
                        datumTokenizer(datum) {
                            return Bloodhound.tokenizers.whitespace(datum.id);
                        },
                        queryTokenizer: Bloodhound.tokenizers.whitespace,
                        prefetch: {
                            url: `${config.url}${config.wildcard ? `${config.wildcard}name=%QUERY` : ''}`,
                            wildcard: config.wildcard ? '%QUERY' : null,
                            filter(tags) {
                                console.log(tags);
                                if (config.object) {
                                    return tags.map(tag => ({
                                        id: tag.id,
                                        name: tag.name
                                    }));
                                }

                                return tags.map(tag => tag.name);
                            }
                        }
                    });
                } else {
                    bloodhound = new Bloodhound({
                        datumTokenizer: Bloodhound.tokenizers.whitespace,
                        queryTokenizer: Bloodhound.tokenizers.whitespace,
                        remote: {
                            url: `${config.url}${config.wildcard ? `${config.wildcard}name=%QUERY` : ''}`,
                            wildcard: config.wildcard ? '%QUERY' : null,
                            filter(tags) {
                                console.log(tags);
                                if (config.object) {
                                    return tags.map(tag => ({
                                        id: tag.id,
                                        name: tag.name
                                    }));
                                }

                                return tags.map(tag => tag.name);
                            }
                        }
                    });
                }

                bloodhound.initialize();

                if (config.object) {
                    this._$element.tagsinput({
                        maxTags: config.maxTags,
                        itemValue: 'id',
                        itemText: 'name',
                        typeaheadjs: [{
                            hint: config.hint,
                            minLength: config.minLength,
                            highlight: config.highlight
                        }, {
                            displayKey: 'name',
                            limit: config.limit,
                            source: bloodhound.ttAdapter(),
                            templates: {
                                notFound: '<div class="dropdown-header highlight text-center">No Results Found</div>'
                            }
                        }]
                    });

                    if (config.values) {
                        config.values.map(value => ({ id: value.id, name: value.name })).forEach(value => this._$element.tagsinput('add', value));
                    }
                } else {
                    this._$element.tagsinput({
                        maxTags: config.maxTags,
                        typeaheadjs: [
                            {
                                hint: config.hint,
                                minLength: config.minLength,
                                highlight: config.highlight
                            }, {
                                limit: config.limit,
                                source: bloodhound.ttAdapter(),
                                templates: {
                                    notFound: '<div class="dropdown-header highlight text-center">No Results Found</div>'
                                }
                            }
                        ]
                    });
                }
            } else {
                this._$element.tagsinput({
                    maxTags: config.maxTags
                });
            }

            this._$element.closest('.form-group').find('input.tt-hint').removeAttr("data-url data-max-tags data-cache data-min-length data-hint data-highlight data-limit data-object data-val data-val-required data-val-maxlength data-val-maxlength-max");
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }


        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    //$this.tagsinput(config);
                    //data = new Token(this, config);
                    //$this.data(DATA_KEY, data);
                    $this.data(DATA_KEY, new Token(this, config));
                }
            });
        }
    }

    $(() => Token._jQueryInterface.call($(Selector.CLASS_NAME)));
    $(document).ajaxStop(() => Token._jQueryInterface.call($(Selector.CLASS_NAME)));

    $.fn[NAME] = Token._jQueryInterface;
    $.fn[NAME].Constructor = Token;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Token._jQueryInterface;
    }

    return Token;
})(jQuery);